var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4A4A4A",
    fillRule: "evenodd",
    stroke: "#4A4A4A",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.275 9.875c0 .075.025.15.05.225.025.025.05.075.075.1.025.025.025.05.05.075 0 0 0 0 0 0l3.175 3.175a.558.558 0 00.8 0 .652.652 0 000-.875l-2.225-2.3h11.025c.3 0 .575-.25.575-.575a.566.566 0 00-.575-.575H6.2l2.225-2.15c.225-.225.225-.55 0-.75-.225-.225-.575-.2-.8.025L4.45 9.475s0 0 0 0c-.025.025-.05.05-.05.1-.025.025-.05.05-.05.1a.399.399 0 00-.075.2h0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6 13.5v4.4H1.35V2.15H12.6v4.125h1.125v-4.15C13.725 1.5 13.25 1 12.675 1h-11.4C.7 1 .225 1.5.225 2.125v15.75C.225 18.5.7 19 1.275 19H12.7c.575 0 1.05-.5 1.05-1.125V13.5H12.6z"
  }))));
}
export default SvgCompany;